import React from 'react';
import modeType from '../../constants/ModeConstants';
import properties from '../../constants/Properties';
import menuType from '../../constants/MenuType';
import { hideMenus, showRecorder } from '../../actions/MenuActions';
import { changeSlideDuration } from '../../actions/CurrentSlideActions';
import { connect } from 'react-redux';
import audioRecorder from '../utils/AudioRecorder';
import locales from '../../locales/LocalesManager';
import configuration from '../../constants/Configuration';
import appParameters from '../../components/utils/AppParameters';
import storeManager from '../../store/StoreManager';
import { SoundElement } from './SoundElement';
import saveManager from '../utils/SaveManager';
import platformDetection from '../../components/utils/PlatformDetection';
import mouseUtils from '../../components/utils/MouseUtils';
import audioUtils from '../utils/AudioUtils';
import animator from '../utils/Animator';
import reactNativeBridge from '../utils/ReactNativeBridge';
import videoUtils from '../utils/VideoUtils';
import playController from '../utils/PlayController';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import hoverManager from '../utils/HoverManager';
import audioVolumeUtils from '../utils/AudioVolumeUtils';
import animationManager from '../utils/AnimationManager';
import textSizeUtils from '../utils/TextSizeUtils';

const RecordingMenuContent = React.createClass({
    getInitialState() {
        return {
            isPlayButtonOver: false,
            isStopButtonOver: false,
            isRecordButtonOver: false,
            isDurationButtonOver: false,
            isMySoundsOver: false,
            isExpanded: false,
            isPlaying: false
        };
    },
    componentDidMount() {
        document.addEventListener('mouseup', this.onCheckExpand);
        document.addEventListener('touchend', this.onCheckExpand);

        if (!playController.isAudioEditorAvailable()) {
            if (!audioVolumeUtils.useVolumeFunctionality()) {
                audioUtils.initRecordedSound(this.updatePlayingStatus);
                audioUtils.initAudioEffect(this.updatePlayingStatus);
            }

            animationManager.pauseSoundStatus = this.pauseSoundStatus;
        }

        videoUtils.updatePlayButtonHandler = this.updatePlayingStatusFromVideo;
        videoUtils.playRegular = this.doPlay;
        playController.updateRecordingMenuButtons = this.updateViewProperties;

        playController.executePlayPause = this.executePlayPause;
        playController.executeStop = this.executeStop;
        playController.changePlayState = this.changePlayState;
    },
    componentWillUnmount() {
        document.removeEventListener('mouseup', this.onCheckExpand);
        document.removeEventListener('touchend', this.onCheckExpand);

        if (audioVolumeUtils.useVolumeFunctionality()) {
            audioVolumeUtils.executeMediaAction('recordedAudio', 0, false);
            audioVolumeUtils.executeMediaAction('audioEffect', 0, false);
        } else {
            audioUtils.cleanRecordingSound();
            audioUtils.cleanAudioEffect();
        }

        videoUtils.updatePlayButtonHandler = undefined;
        videoUtils.playRegular = undefined;
        playController.updateRecordingMenuButtons = undefined;

        playController.executePlayPause = undefined;
        playController.executeStop = undefined;
        playController.changePlayState = undefined;
    },
    onMySoundsMouseIn() {
        hoverManager.show(this.refs.mySoundsHolder, 'MySoundsTitle');

        this.setState({
            isMySoundsOver: true
        });
    },
    onMySoundsMouseOut() {
        hoverManager.hide();

        this.setState({
            isMySoundsOver: false
        });
    },
    onPlayButtonMouseIn() {
        if (playController.isAudioEditorMode())
            hoverManager.show(this.refs.play, 'playCartoon');
        else
            hoverManager.show(this.refs.play, 'playSlide');

        this.setState({
            isPlayButtonOver: true
        });
    },
    onPlayButtonMouseOut() {
        hoverManager.hide();

        this.setState({
            isPlayButtonOver: false
        });
    },
    onStopButtonMouseIn() {
        hoverManager.show(this.refs.stop, 'stop');

        this.setState({
            isStopButtonOver: true
        });
    },
    onStopButtonMouseOut() {
        hoverManager.hide();

        this.setState({
            isStopButtonOver: false
        });
    },
    onRecordButtonMouseIn() {
        hoverManager.show(this.refs.recordingHolder, locales.getCaption('RecordSoundAlert', 'record'), 'top', true);

        this.setState({
            isRecordButtonOver: true
        });
    },
    onRecordButtonMouseOut() {
        hoverManager.hide();

        this.setState({
            isRecordButtonOver: false
        });
    },
    onDurationButtonMouseIn() {
        hoverManager.show(this.refs.duration, 'slideDuration');

        this.setState({
            isDurationButtonOver: true
        });
    },
    onDurationButtonMouseOut() {
        hoverManager.hide();

        this.setState({
            isDurationButtonOver: false
        });
    },
    onDurationClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        if (playController.isPlaying)
            return;

        if (videoUtils.isVideoBackground() && !videoUtils.showVideoEditor()) {
            videoUtils.changeToVideoEditorMode();

            hoverManager.hide();
        }
    },
    onDurationClickByKeyboard() {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000 || document.activeElement != this.refs.durationButton)
            return;

        if (!playController.isPlaying) {

            if (videoUtils.isVideoBackground() && !videoUtils.showVideoEditor()) {
                videoUtils.changeToVideoEditorMode();

                hoverManager.hide();
            }
        }

        this.expand();
    },
    onCheckExpand (e) {
        if (textSizeUtils.isTextEditMode())
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        var target = e.target;

        if (target) {
            var type = typeof  target.className;

            if (type == 'string') {
                if (target.className.indexOf('slideDurationInput') < 0) {
                    this.setState({
                        isExpanded: false
                    });
                }
            } else {
                this.setState({
                    isExpanded: false
                });
            }
        }
    },
    onExpand (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        this.expand();
    },
    expand() {
        const isExpanded = this.state.isExpanded;
        this.setState({
            isExpanded: !isExpanded
        });
    },
    onOpenMySounds (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        playController.checkAudioEditorModeWhenOpenAudioMenus(1);
    },
    onClick(e) {
        if (e.target && e.target.parentElement && e.target.parentElement.id == 'mySounds')
            return;

        if (!animationManager.isAnimationMode())
            this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
    },
    componentWillReceiveProps(nextProps) {
        if (this.props.currentSlideIndex != nextProps.currentSlideIndex) {
            this.setState({
                isExpanded: false
            });

            this.stopSound();
        }
    },
    onRecordDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (playController.isPlaying || this.props.refreshAudioElements)
            return;

        if (platformDetection.isIOSApp()) {
            if (!reactNativeBridge.isIOSRecorderEnabled)
                reactNativeBridge.init(this.initRecording);
            else
                this.props.dispatch(showRecorder(true));
        } else {
            if (!audioRecorder.isRecordAvailable)
                audioRecorder.init(this.initRecording);
            else
                this.props.dispatch(showRecorder(true));
        }
    },
    initRecording() {
        if (platformDetection.isIOSApp())
            reactNativeBridge.isIOSRecorderEnabled = true;

        this.props.dispatch(showRecorder(true));
    },
    stopSound() { // used when click on another slide while playing the old one
        if (this.isSoundVisible()) {
            if (this.state.isPlaying) {
                if (audioVolumeUtils.useVolumeFunctionality())
                    audioVolumeUtils.executeMediaAction('recordedAudio', 0, false);
                else
                    audioUtils.pauseSound('recordedAudio');
            }
        }

        if (this.isSoundEffectVisible()) {
            if (this.state.isPlaying) {
                if (audioVolumeUtils.useVolumeFunctionality())
                    audioVolumeUtils.executeMediaAction('audioEffect', 0, false);
                else
                    audioUtils.pauseSound('audioEffect');
            }
        }

        if (this.isVideoVisible()) {
            if (this.state.isPlaying)
                videoUtils.pauseVideoPreview();
        } else {
            if (this.isVideoShapeVisible()) {
                if (this.state.isPlaying)
                    videoUtils.pauseVideoShapesPreview();
            }
        }
    },
    changePlayState(value) {
        this.setState({
            isPlaying: value
        });
    },
    getStartOffset() {
        return videoUtils.getPlayOffset();
    },
    executeStop() {
        this.setState({
            isPlaying: false
        });

        if (playController.isAudioEditorAvailable())
            playController.stop();
    },
    onStop(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (animationManager.isAnimationMode()) {
            animationManager.stopAnimationIndEditMode();
        } else
        if (animationManager.isAnimatedSlide()) {
            animationManager.stopAnimations();
        }

        if (playController.isAudioEditorAvailable()) {
            this.setState({
                isPlaying: false
            });

            playController.stop();

            return;
        }

        this.clearEndSlideTimer();

        this.setState({
            isPlaying: false
        });

        if (this.isSoundVisible()) {
            if (audioVolumeUtils.useVolumeFunctionality()) {
                audioVolumeUtils.executeMediaAction('recordedAudio', 0, false);
            } else {
                audioUtils.pauseSound('recordedAudio');
                var audio = document.getElementById('recordedAudio');

                if (audio)
                    audio.currentTime = 0;
            }
        }

        if (this.isSoundEffectVisible()) {
            if (audioVolumeUtils.useVolumeFunctionality()) {
                audioVolumeUtils.executeMediaAction('audioEffect', 0, false);
            } else {
                audioUtils.pauseSound('audioEffect');
                var audioEffect = document.getElementById('audioEffect');

                if (audioEffect)
                    audioEffect.currentTime = 0;
            }
        }

        if (this.isVideoVisible()) {
            videoUtils.pauseVideoPreview(true);
        } else {
            if (this.isVideoShapeVisible()) {
                videoUtils.pauseVideoShapesPreview(true);
            }
        }
    },
    isPlayAvailable() {
        if (this.isSoundVisible() || this.isSoundEffectVisible() || this.isVideoVisible() || this.isVideoShapeVisible() || animationManager.isAnimatedSlide() || animationManager.isAnimationMode())
            return true;
        else
            return false;
    },
    onPlay(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (playController.isAudioEditorAvailable())
            this.doNewPlay();
        else
            this.doPlay();
    },
    executePlayPause() {
        if (playController.isAudioEditorAvailable())
            this.doNewPlay();
    },
    doNewPlay() {
        if (this.state.isPlaying)
            playController.pause();
        else
            playController.play();

        if (animationManager.isAnimationMode()) {
            if (!this.state.isPlaying) { // play
                animationManager.startAnimationInEditMode();
            } else { // pause
                animationManager.stopAnimationIndEditMode();
            }
        } else
        if (animationManager.isAnimatedSlide()) {
            if (!this.state.isPlaying) { // play
                animationManager.startAnimations(true);
            } else { // pause
                animationManager.stopAnimations(true);
            }
        }

        this.togglePlayState();
    },
    onEndSlideTime() {
        if (this.state.isPlaying) {
            if (this.isSoundVisible()) {
                if (audioVolumeUtils.useVolumeFunctionality()) {
                    audioVolumeUtils.executeMediaAction('recordedAudio', 0, false);
                } else {
                    audioUtils.pauseSound('recordedAudio', true);
                    audioUtils.restartAudio('recordedAudio');
                }
            }

            if (this.isSoundEffectVisible()) {
                if (audioVolumeUtils.useVolumeFunctionality()) {
                    audioVolumeUtils.executeMediaAction('audioEffect', 0, false);
                } else {
                    audioUtils.pauseSound('audioEffect', true);
                    audioUtils.restartAudio('audioEffect');
                }
            }

            if (this.isVideoVisible())
                videoUtils.pauseVideoPreview(true);
            else {
                if (this.isVideoShapeVisible())
                    videoUtils.pauseVideoShapesPreview(true);
            }

            this.setState({
                isPlaying: false
            });

            if (animationManager.isAnimatedSlide())
                animationManager.stopAnimations();

            this.forceUpdate();
        }
    },
    clearEndSlideTimer() {
        if (audioUtils.endCurrentSlideTimer)
            clearTimeout(audioUtils.endCurrentSlideTimer);
    },
    doPlay() {
        if (!this.isPlayAvailable())
            return;

        var offset = this.getStartOffset();
        this.clearEndSlideTimer();

        if (!this.state.isPlaying) { // will do a play
            var slideTime = storeManager.getState().currentSlide.model.time;
            var recordedAudio = document.getElementById('recordedAudio');
            var audioEffect = document.getElementById('audioEffect');

            if (Math.abs(recordedAudio.duration - slideTime) > 1 || Math.abs(audioEffect.duration - slideTime) > 1)
                audioUtils.endCurrentSlideTimer = setTimeout(this.onEndSlideTime, slideTime * 1000);
            else
                audioUtils.endCurrentSlideTimer = undefined;
        } else {
            audioUtils.endCurrentSlideTimer = undefined;
        }

        if (this.isVideoVisible()) {
            if (!this.state.isPlaying) {
                videoUtils.playVideoPreview(offset);
            } else {
                videoUtils.pauseVideoPreview();
            }
        } else {
            if (this.isVideoShapeVisible()) {
                if (!this.state.isPlaying) {
                    videoUtils.playVideoShapesPreview();
                } else {
                    videoUtils.pauseVideoShapesPreview();
                }
            }
        }

        if (this.isSoundVisible()) {
            if (!this.state.isPlaying) {
                if (audioVolumeUtils.useVolumeFunctionality()) {
                    audioVolumeUtils.executeMediaAction('recordedAudio', audioUtils.getSoundVolume('recordedAudio'), true, this.onEndSound);
                } else {
                    audioUtils.setSoundVolume('recordedAudio');
                    audioUtils.playSound('recordedAudio');
                }
            } else {
                if (audioVolumeUtils.useVolumeFunctionality())
                    audioVolumeUtils.executeMediaAction('recordedAudio', 0, false);
                else
                    audioUtils.pauseSound('recordedAudio');
            }
        }

        if (this.isSoundEffectVisible()) {
            if (!this.state.isPlaying) {
                if (audioVolumeUtils.useVolumeFunctionality()) {
                    audioVolumeUtils.executeMediaAction('audioEffect', audioUtils.getSoundVolume('audioEffect'), true, this.onEndSound);
                } else {
                    audioUtils.setSoundVolume('audioEffect');
                    audioUtils.playSound('audioEffect');
                }
            } else {
                if (audioVolumeUtils.useVolumeFunctionality())
                    audioVolumeUtils.executeMediaAction('audioEffect', 0, false);
                else
                    audioUtils.pauseSound('audioEffect');
            }
        }

        if (animationManager.isAnimationMode()) {
            if (!this.state.isPlaying) { // play
                animationManager.startAnimationInEditMode();
            } else { // pause
                animationManager.stopAnimationIndEditMode();
            }
        } else
        if (animationManager.isAnimatedSlide()) {
            if (!this.state.isPlaying) { // play
                animationManager.startAnimations(true);
            } else { // pause
                animationManager.stopAnimations(true);
            }
        }

        this.togglePlayState();
    },
    togglePlayState() {
        if (!this.state.isPlaying) {
            this.setState({
                isPlaying: true
            });
        } else {
            this.setState({
                isPlaying: false
            });
        }
    },
    updatePlayingStatus(value, isSoundEffect = false, isEnded = false) {
        if (this.isSoundVisible() && isSoundEffect)
            return;

        if (audioUtils.endCurrentSlideTimer)
            return;

        if (!value && this.isSoundVisible()) {
            if (audioVolumeUtils.useVolumeFunctionality())
                audioVolumeUtils.executeMediaAction('recordedAudio', 0, false);
            else
                audioUtils.pauseSound('recordedAudio');
        }

        if (!value && this.isSoundEffectVisible()) {
            if (audioVolumeUtils.useVolumeFunctionality())
                audioVolumeUtils.executeMediaAction('audioEffect', 0, false);
            else
                audioUtils.pauseSound('audioEffect');
        }

        if (isEnded) {
            if (audioVolumeUtils.useVolumeFunctionality()) {
                audioVolumeUtils.executeMediaAction('recordedAudio', 0, false);
                audioVolumeUtils.executeMediaAction('audioEffect', 0, false);
            } else {
                audioUtils.restartAudio('recordedAudio');
                audioUtils.restartAudio('audioEffect');
            }
        }

        this.setState({
            isPlaying: value
        });

        this.forceUpdate();
    },
    onEndSound() {
        if (audioVolumeUtils.useVolumeFunctionality()) {
            audioVolumeUtils.executeMediaAction('recordedAudio', 0, false);
            audioVolumeUtils.executeMediaAction('audioEffect', 0, false);
        }

        this.pauseSoundStatus();
    },
    pauseSoundStatus() {
        this.setState({
            isPlaying: false
        });
    },
    updatePlayingStatusFromVideo(value, isEnded = false) {
        if (!value && this.isSoundVisible()) {
            if (audioVolumeUtils.useVolumeFunctionality())
                audioVolumeUtils.executeMediaAction('recordedAudio', 0, false);
            else
                audioUtils.pauseSound('recordedAudio');
        }

        if (!value && this.isSoundEffectVisible()) {
            if (audioVolumeUtils.useVolumeFunctionality())
                audioVolumeUtils.executeMediaAction('audioEffect', 0, false);
            else
                audioUtils.pauseSound('audioEffect');
        }

        if (isEnded) {
            if (audioVolumeUtils.useVolumeFunctionality()) {
                audioVolumeUtils.executeMediaAction('recordedAudio', 0, false);
                audioVolumeUtils.executeMediaAction('audioEffect', 0, false);
            } else {
                audioUtils.restartAudio('recordedAudio');
                audioUtils.restartAudio('audioEffect');
            }
        }

        this.setState({
            isPlaying: value
        });

        if (!value) {
            var video = document.getElementById('videoBackground');
            video.currentTime = videoUtils.getStartPoint();
        }

        this.forceUpdate();
    },
    isSoundVisible () {
        var audioSource = this.getAudioSource();

        if (audioSource && audioSource != '')
            return true;
        else
            return false;
    },
    isSoundEffectVisible () {
        var audioSource = this.getAudioEffectSource();

        if (audioSource && audioSource != '')
            return true;
        else
            return false;
    },
    isVideoVisible() {
        return videoUtils.isVideoBackground();
    },
    isVideoShapeVisible() {
        return videoUtils.isVideoShapes();
    },
    getAudioSource() {
        var value;

        if (this.props.soundWav != undefined && this.props.soundWav != '' && this.props.soundWav.length > 0)
            value = this.props.soundWav;
        else
        if (this.props.sound != undefined && this.props.sound != '' && this.props.sound.length > 0)
            value = this.props.sound;

        if (audioVolumeUtils.useVolumeFunctionality())
            audioVolumeUtils.checkSound(value, 'recordedAudio');
        else
            audioUtils.updateHrefForRecordedSound(value);

        return value;
    },
    getAudioEffectSource() {
        var value;

        if (this.props.soundEffect != undefined && this.props.soundEffect != '' && this.props.soundEffect.length > 0)
            value = this.props.soundEffect;

        if (audioVolumeUtils.useVolumeFunctionality())
            audioVolumeUtils.checkSound(value, 'audioEffect');
        else
            audioUtils.updateHrefForAudioEffect(value);

        return value;
    },
    refreshView() {
        this.forceUpdate();
    },
    updateViewProperties() {
        this.setState({
            isPlaying: false
        });

        this.refreshView();
    },
    onInputBlur() {
        var duration = parseFloat(this.refs.textDuration.value);

        if (duration > 0) {
            audioEditorUtils.refreshAllSlidesRenderers = true;

            duration = parseFloat(duration.toFixed(1));
            this.props.dispatch(changeSlideDuration(duration));

            saveManager.isContentChanged(true);
            audioEditorUtils.checkTimelineWidth();
            playController.updateCurrentSlideProperties();
            playController.updateScrollPosition(100, true);
            saveManager.isContentChanged(true);
        }

        this.forceUpdate();
    },
    onChangeText() {
        const tenMinutes = 600; //seconds
        if (this.refs.textDuration.value > tenMinutes)
            this.refs.textDuration.value = tenMinutes;

        this.forceUpdate();
    },
    updateDurationText() {
        if (this.isDurationFocus())
            return;

        setTimeout(function() {
            var duration;

            if (this.props.duration)
                duration = parseFloat(this.props.duration);

            let textValue = duration ? duration.toFixed(1) : 0;

            if (this.refs && this.refs.textDuration && textValue > 0)
                this.refs.textDuration.value = textValue;
        }.bind(this), 10);
    },
    isExpandedState() {
        return this.isDurationFocus();
    },
    isDurationFocus() {
        if (document.activeElement == this.refs.textDuration)
            return true;
        else
            return false;
    },
    onSetTextFocus() {
        playController.getOldScrollPosition();

        setTimeout(function() {
            if (this.refs.textDuration) {
                this.refs.textDuration.focus();
                // this.refs.textDuration.setSelectionRange(0, 100);
            }
        }.bind(this), 10);
    },
    shouldComponentUpdate(newProps, nextState) {
        if (newProps.currentSlideIndex == this.props.currentSlideIndex) {
            if (newProps.soundEffect && this.props.soundEffect != newProps.soundEffect) {
                animator.startAnimation('slideSoundEffect');
                return true;
            }

            if (newProps.soundWav && newProps.soundWav.length > 0) {
                if (this.props.soundWav != newProps.soundWav)
                    animator.startAnimation('slideSound');
            } else if (newProps.sound && this.props.sound != newProps.sound) {
                animator.startAnimation('slideSound');
            }
        }

        return true;
    },
    render() {
        if (this.props.mode == modeType.PREVIEW || this.props.showVideoEditor)
            return (<div/>);

        const width = configuration.CANVAS_WIDTH * this.props.scaleProperties.scale;
        const height = properties.RECORDING_MENU_HEIGHT;
        const borderSize = 1;

        var menuStyle = {
            position: 'absolute',
            backgroundColor: properties.RECORDING_MENU_BACKGROUND,
            width: width,
            height: height,
            top: this.props.scaleProperties.topY + configuration.CANVAS_HEIGHT * this.props.scaleProperties.scale,
            left: this.props.scaleProperties.topX,
            cursor: 'default',
            userSelect: 'none',
            userDrag: 'none',
            WebkitUserSelect: 'none'
        };

        if (this.props.contextMode == modeType.LINE_CONTEXT || this.props.contextMode == modeType.FREEHAND_CONTEXT) {
            menuStyle.pointerEvents = 'none';
            menuStyle.opacity = 0.5;
        }

        // PLAY button
        var borderColor = 'white';
        var iconColor;
        var tabIndexPlay;

        if (playController.isAudioEditorAvailable()) {
            if (this.state.isPlayButtonOver == true) {
                iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            } else {
                iconColor = 'black';
            }
        } else {
            if (!this.isPlayAvailable()) {
                iconColor = properties.RECORDING_MENU_BACKGROUND;
                tabIndexPlay = '-1';
            } else if (this.state.isPlayButtonOver == true) {
                iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            } else {
                iconColor = 'black';
            }
        }

        const playStyle = {
            width: properties.RECORDING_PLAY_BUTTON_WIDTH,
            height: properties.RECORDING_BUTTON_HEIGHT,
            background: 'white',
            position: 'absolute',
            left: properties.RECORDING_GAP,
            top: (properties.RECORDING_MENU_HEIGHT - properties.RECORDING_BUTTON_HEIGHT) / 2 - borderSize,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 3,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        var playIcon = 'fa fa-play';
        var playIconPosition = 24;

        if (this.state.isPlaying) {
            playIcon = 'fa fa-pause';
            playIconPosition = 22;
        }

        const playIconStyle = {
            position: 'absolute',
            top: 6,
            left: playIconPosition,
            color: iconColor
        };

        // STOP button
        borderColor = 'white';

        if (playController.isAudioEditorAvailable()) {
            if (this.state.isStopButtonOver == true) {
                iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            } else {
                iconColor = 'black';
            }
        } else {
            if (!this.isPlayAvailable()) {
                iconColor = properties.RECORDING_MENU_BACKGROUND;
            } else if (this.state.isStopButtonOver == true) {
                iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            } else {
                iconColor = 'black';
            }
        }

        const stopStyle = {
            width: properties.RECORDING_PLAY_BUTTON_WIDTH,
            height: properties.RECORDING_BUTTON_HEIGHT,
            background: 'white',
            position: 'absolute',
            left: properties.RECORDING_GAP * 2 + properties.RECORDING_PLAY_BUTTON_WIDTH,
            top: (properties.RECORDING_MENU_HEIGHT - properties.RECORDING_BUTTON_HEIGHT) / 2 - borderSize,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 3,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const stopIcon = 'fa fa-stop';
        const stopIconStyle = {
            position: 'absolute',
            top: 6,
            left: 21,
            color: iconColor
        };

        // RECORD Button
        const recordMiddleGap = 8;
        const recordButtonSize = properties.RECORDING_BUTTON_HEIGHT;
        var recordButtonLeftPos = width / 2 - recordButtonSize - recordMiddleGap / 2;
        var recordIcon;

        if (this.state.isRecordButtonOver == true)
            recordIcon = 'assets/recordHover.png';
        else
            recordIcon = 'assets/record.png';

        borderColor = 'red';

        const recordStyle = {
            width: recordButtonSize,
            height: recordButtonSize,
            position: 'absolute',
            left: recordButtonLeftPos,
            top: (properties.RECORDING_MENU_HEIGHT - recordButtonSize) / 2,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none',
            borderRadius: 100
        };

        const recordIconStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: recordButtonSize,
            height: recordButtonSize
        };

        // DURATION button
        if (this.state.isDurationButtonOver == true) {
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        }
        else {
            borderColor = 'white';
            iconColor = properties.DURATION_SLIDER_COLOR;
        }

        var durationWidth;
        var offset = 0;

        if (this.isExpandedState()) {
            durationWidth = properties.RECORDING_DURATION_BUTTON_EXPANDED + 15;
            offset = properties.RECORGING_SLIDER_WIDTH + 10;
        } else
            durationWidth = properties.RECORDING_DURATION_BUTTON_WIDTH;

        const durationLabelStyle = {
            display: !this.isExpandedState() ? "none" : "inline-block",
            marginTop: "5px",
            paddingLeft: "5px",
            fontSize: "14px"
        }

        var durationStyle = {
            width: durationWidth,
            height: properties.RECORDING_BUTTON_HEIGHT,
            background: 'white',
            position: 'absolute',
            left: width - properties.RECORDING_GAP - durationWidth,
            top: (properties.RECORDING_MENU_HEIGHT - properties.RECORDING_BUTTON_HEIGHT) / 2 - borderSize,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 30,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const durationWrapperStyle = {
            position: 'absolute',
            width: properties.RECORDING_DURATION_BUTTON_WIDTH,
            height: properties.RECORDING_BUTTON_HEIGHT,
            top: 0,
            left: offset
        };

        const durationIconStyle = {
            color: 'black',
            marginLeft: '8px',
            marginTop: '6px'
        };

        var durationSpanStyle = {
            fontSize: 12,
            height: 20,
            width: 35,
            whiteSpace: 'nowrap',
            cursor: 'default',
            position: 'absolute',
            top: 3,
            left: 28,
            color: 'black',
            textAlign: 'center',
            border: 'none'
        };

        if (platformDetection.isIOS()) {
            durationSpanStyle.left = 27;
            durationSpanStyle.height = 16;
            durationSpanStyle.width = 24;
        }

        var sliderVisibility;

        if (this.isExpandedState())
            sliderVisibility = 'flex';
        else
            sliderVisibility = 'none';

        var sliderProperties = {};
        sliderProperties.topPosition = 0;
        sliderProperties.leftPosition = 12;
        sliderProperties.width = properties.RECORGING_SLIDER_WIDTH;
        sliderProperties.height = properties.RECORDING_BUTTON_HEIGHT;
        sliderProperties.thumbSize = properties.STYLING_THUMB_SIZE - 2;
        sliderProperties.start = 1;
        sliderProperties.end = 30;
        sliderProperties.step = 1;
        sliderProperties.dispatch = this.props.dispatch;
        sliderProperties.display = sliderVisibility;
        sliderProperties.slideDuration = this.props.duration;
        sliderProperties.currentSlideIndex = this.props.currentSlideIndex;

        // MySounds button
        var mySoundsStyle = {
            position: 'absolute',
            left: width / 2  + recordMiddleGap / 2,
            top: (properties.RECORDING_MENU_HEIGHT - recordButtonSize) / 2,
            width: recordButtonSize,
            height: recordButtonSize,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none',
            borderRadius: 100
        };

        const mySoundsIconStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: recordButtonSize,
            height: recordButtonSize
        };

        var recordingHolderStyle = {};
        var mySoundsIcon;

        if (this.state.isMySoundsOver == true)
            mySoundsIcon = appParameters.RESOURCES_LOCATION() + 'assets/mySoundsHover.png';
        else
            mySoundsIcon = appParameters.RESOURCES_LOCATION() + 'assets/mySounds.png';

        var audioRecorded;
        var audioEffect;
        var recordedSound;
        var effectSound;

        if (!playController.isAudioEditorAvailable()) {
            audioRecorded = <audio id='recordedAudio' ref='audio' src={this.getAudioSource()} className='audioItem' preload='auto' playsInline/>;
            audioEffect = <audio id='audioEffect' src={this.getAudioEffectSource()} className='audioItem' preload='auto' playsInline/>;

            recordedSound = <SoundElement dispatch={this.props.dispatch} scaleProperties={this.props.scaleProperties} audioSource={this.getAudioSource()} soundTitle={this.props.soundTitle} updateViewProperties={this.updateViewProperties} isSoundEffect={false}/>;
            effectSound = <SoundElement dispatch={this.props.dispatch} scaleProperties={this.props.scaleProperties} audioSource={this.getAudioEffectSource()} soundTitle={this.props.soundEffectTitle} updateViewProperties={this.updateViewProperties} isSoundEffect={true}/>;
        }

        if (playController.isAudioEditorAvailable()) {
            mySoundsStyle.display = 'none';
            recordStyle.left = width / 2 - recordButtonSize / 2;
        }

        this.updateDurationText();

        var tabIndexMiddleElements;

        if (this.props.contextMode == modeType.ANIMATION_CONTEXT) {
            recordingHolderStyle.pointerEvents = 'none';
            recordingHolderStyle.opacity = 0.5;

            mySoundsStyle.pointerEvents = 'none';
            mySoundsStyle.opacity = 0.5;

            tabIndexMiddleElements = '-1';
        }

        var playAriaLabel = '';

        if (playController.isAudioEditorMode())
            playAriaLabel = locales.getCaption('playCartoon', 'hover');
        else
            playAriaLabel = locales.getCaption('playSlide', 'hover');

        var tabIndexValue;

        if (document.activeElement.id == 'durationThumbButton')
            tabIndexValue = '-1';

        const fillOutFieldViewWidth = 150;
        var fillOutFieldViewStyle = {
            position: 'absolute',
            background: '#434343',
            width: fillOutFieldViewWidth,
            height: 30,
            top: 36,
            left: -27,
            borderRadius: 5,
            zIndex: 99999,
            pointerEvents: 'none'
        };

        const stemStyle = {
            position: 'absolute',
            borderWidth: 10,
            borderStyle: 'solid',
            borderBottomColor: '#434343',
            borderTopColor: 'transparent',
            borderLeftColor: 'transparent',
            borderRightColor: 'transparent',
            top: -20,
            left: fillOutFieldViewWidth/2 - 10
        };

        const captionStyle = {
            position: 'absolute',
            color: 'white',
            wordWrap: 'break-word',
            textAlign: 'center',
            fontSize: 12,
            left: 5,
            top: 8,
            width: fillOutFieldViewWidth - 10
        };

        var fillOutFieldView;
        var isEmptyTitle = this.refs.textDuration && this.refs.textDuration.value.length < 1;
        var isNaNValue = this.refs.textDuration && isNaN(this.refs.textDuration.value);

        if (isEmptyTitle || isNaNValue) {
            var alertText = isEmptyTitle ? locales.getCaption('emptyInput', 'other') : locales.getCaption('notANumberInput', 'other');

            if (alertText.indexOf('other') != -1)
                alertText = isEmptyTitle ? 'Please fill out this field!' : 'The value is not correct!';

            fillOutFieldView =
                <div style={fillOutFieldViewStyle}>
                    <div style={stemStyle}></div>
                    <div style={captionStyle}>
                        {alertText}
                    </div>
                </div>;
        }

        return (
            <div id='recordingMenu' style={menuStyle} onMouseDown={this.onClick} onTouchEnd={this.onClick}>
                {audioRecorded}
                {audioEffect}
                <button ref='play' tabIndex={tabIndexPlay} aria-disabled={tabIndexPlay == '-1' ? true : false} aria-label={playAriaLabel} style={playStyle} onMouseOver={this.onPlayButtonMouseIn} onMouseOut={this.onPlayButtonMouseOut} onClick={this.onPlay} onTouchEnd={this.onPlay}>
                    <i style={playIconStyle} className={playIcon}></i>
                </button>
                <button ref='stop' tabIndex={tabIndexPlay} aria-disabled={tabIndexPlay == '-1' ? true : false} aria-label={locales.getCaption('stop', 'hover')} style={stopStyle} onMouseOver={this.onStopButtonMouseIn} onMouseOut={this.onStopButtonMouseOut} onClick={this.onStop} onTouchEnd={this.onStop}>
                    <i style={stopIconStyle} className={stopIcon}></i>
                </button>
                {recordedSound}
                {effectSound}
                <div style={recordingHolderStyle}>
                    <button ref='recordingHolder' tabIndex={tabIndexMiddleElements} aria-disabled={tabIndexMiddleElements == '-1' ? true : false} aria-label={locales.getCaption('RecordSoundAlert', 'record')} style={recordStyle} onMouseOver={this.onRecordButtonMouseIn} onMouseOut={this.onRecordButtonMouseOut} onClick={this.onRecordDown} onTouchStart={this.onRecordDown}>
                        <img alt={locales.getCaption('RecordSoundAlert', 'record')} aria-hidden='true' style={recordIconStyle} src={appParameters.RESOURCES_LOCATION() + recordIcon}/>
                    </button>
                </div>
                <button id='mySounds' ref='mySoundsHolder' tabIndex={tabIndexMiddleElements} aria-disabled={tabIndexMiddleElements == '-1' ? true : false} aria-label={locales.getCaption('MySoundsTitle', 'music')} style={mySoundsStyle} onTouchEnd={this.onOpenMySounds} onClick={this.onOpenMySounds} onMouseOver={this.onMySoundsMouseIn} onMouseOut={this.onMySoundsMouseOut}>
                    <img alt={locales.getCaption('MySoundsTitle', 'music')} aria-hidden='true' style={mySoundsIconStyle} src={mySoundsIcon}/>
                </button>
                <div ref='durationButton' className='slideDuration' style={durationStyle} onMouseOver={this.onDurationButtonMouseIn} onMouseOut={this.onDurationButtonMouseOut} onTouchStart={this.onDurationClick} onMouseDown={this.onDurationClick} onClick={this.onDurationClickByKeyboard}>
                    <i aria-hidden={true} style={durationIconStyle} className="fa fa-clock-o slideDuration" onTouchEnd={this.onSetTextFocus} onMouseDown={this.onSetTextFocus}></i>
                    <label style={durationLabelStyle} htmlFor="slideDurationInput">{locales.getCaption('slideDurationInputLabel', 'other')}</label>
                    <div className='slideDuration slideDurationInput' style={durationWrapperStyle} onTouchStart={this.onExpand} onMouseDown={this.onExpand}>
                        <input id="slideDurationInput" type='text' ref='textDuration' className='slideDuration titleInput' style={durationSpanStyle} spellCheck='false' autoCorrect='off' autoCapitalize='off' autoComplete='off' onChange={this.onChangeText} onTouchStart={this.onSetTextFocus} onMouseDown={this.onSetTextFocus} onBlur={this.onInputBlur} onFocus={this.onCheckExpand}/>
                        {fillOutFieldView}
                    </div>
                </div>
                <div id="qq-template">
                    <div id="qq-template2">
                    </div>
                </div>
            </div>
        );
    }
});

function mapStateToProps(state) {
    const duration = state.currentSlide.model.time;
    const currentSlideIndex = state.currentSlide.currentSlideIndex;
    const soundEffect = state.currentSlide.model.soundEffect;
    const sound = state.currentSlide.model.sound;
    const soundWav = state.currentSlide.model.soundWav;
    const slideModel = state.currentSlide.model;
    var soundTitle = state.currentSlide.model.soundTitle;
    var soundEffectTitle = state.currentSlide.model.soundEffectTitle;
    var showVideoEditor = state.menu.showVideoEditor;
    const contextMode = state.menu.contextMode;
    var refreshAudioElements = state.audioEditor.refreshAudioElements;

    if (refreshAudioElements == undefined)
        refreshAudioElements = false;

    if (!soundTitle)
        soundTitle = '';

    if (!soundEffectTitle)
        soundEffectTitle = '';

    if (!showVideoEditor)
        showVideoEditor = false;

    return {
        duration,
        currentSlideIndex,
        sound,
        soundWav,
        slideModel,
        soundTitle,
        showVideoEditor,
        soundEffectTitle,
        soundEffect,
        contextMode,
        refreshAudioElements
    };
}

export const RecordingMenu = connect(mapStateToProps)(RecordingMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/RecordingMenu.js
 **/